import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorize-page',
  templateUrl: './unauthorize-page.component.html',
})
export class UnauthorizePageComponent implements OnInit {

  constructor() {
    // This is intentional
   }

  ngOnInit(): void {
    // This is intentional
  }

}
